import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';
import Theme from 'Theme';

const baseStyles = {
    container: {
        flexDirection: 'row',
        flex: 1
    },
    iconContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        // width: 100,
        flexBasis: 100,
        height: 70
    },
    icon: {
        width: 50,
        height: 40,
        marginStart: 18,
        marginEnd: 18,
        marginBottom: 12
    },
    customIcon: {
        marginStart: 18,
        marginBottom: 12
    },
    contentWrapper: {
        flex: 1,
        paddingRight: Device.isWeb ? 0 : 20
    },
    content: {
        paddingEnd: 12,
        flexDirection: 'row',
        alignItems: 'center'
    },
    programTitle: {
        fontFamily: Theme.regularFont,
        fontSize: 24,
        maxWidth: '87.5%',
        color: Theme.primaryTextColor
    },
    programTitleHidden: {
        color: Theme.secondaryTextColor
    },
    programSubtitle: {
        maxWidth: '80%',
        fontFamily: Theme.regularFont,
        fontSize: 15,
        color: Theme.secondaryTextColor,
        marginBottom: 10
    },
    iconWrapper: {
        flex: 1
    },
    lockIcon: {
        marginStart: 12,
        width: 22,
        height: 22
    }
};

export default StyleSheet.create(baseStyles);
